import { render, staticRenderFns } from "./ProductRelated.vue?vue&type=template&id=a8c9545c&scoped=true&"
import script from "./ProductRelated.vue?vue&type=script&lang=js&"
export * from "./ProductRelated.vue?vue&type=script&lang=js&"
import style0 from "./ProductRelated.vue?vue&type=style&index=0&id=a8c9545c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c9545c",
  null
  
)

export default component.exports